import React, { useContext, useEffect } from "react";
import { v4 as uuid4 } from "uuid";
import EditableMenuItem from "./EditableMenuItem";
import EditableMenuTitle from "./EditableMenuTitle";
import EditableMenuDropper from "./EditableMenuDropper";

import { MenuContext } from "./Contexts/MenuContext";
import { getTheme } from "@fluentui/react";

import * as utilMenu from "./Functions/util-menu";

export const EditableMenu = function EditableMenu() {
  const [menuContext, setMenuContext] = useContext(MenuContext);

  useEffect(() => {
    if (menuContext.menuEditStateDisplay) {
      setTimeout(
        () =>
          setMenuContext((prevState) => ({
            ...prevState,
            menuEditStateDisplay:
              prevState.menuEditStateId === menuContext.menuEditStateId
                ? false
                : prevState.menuEditStateDisplay,
          })),
        (window.configs.MENU_EDIT_MESSAGE_TIMEOUT ?? 30) * 1000
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    menuContext.menuEditStateDisplay,
    menuContext.menuEditStateId,
    menuContext.menuEditStateMessage,
  ]);

  const removeMenuItem = (deleteKey) => {
    setMenuContext((prevState) => ({
      ...prevState,
      menuEdit: utilMenu.removeMenuItem(prevState.menuEdit, deleteKey, false),
    }));
  };

  const addMenuItem = (seedKey) => {
    setMenuContext((prevState) => ({
      ...prevState,
      menuEdit: utilMenu.addMenuItem(
        prevState.menuEdit,
        utilMenu.getMenuItemByKey(prevState.menuEdit, seedKey)?.parent ?? null,
        {
          ...(utilMenu.getMenuItemByKey(prevState.menuEdit, seedKey) ??
            utilMenu.newMenuItem()),
          key: uuid4().toString(),
        }
      ),
    }));
  };

  const moveMenuItem = (dragId, dropId) => {
    // cannot move to self
    if (dragId === dropId) {
      console.log(`Cannot drag an item to itself`);
      return;
    }

    // cannot place item in child
    if (
      utilMenu
        .getChildKeys(menuContext.menuEdit, dragId, false)
        .some((key) => key === dropId)
    ) {
      console.log(`Cannot drag an item into a child item`);
      return;
    }

    setMenuContext((prevState) => ({
      ...prevState,
      menuEdit: utilMenu.moveMenuItem(prevState.menuEdit, dropId, dragId, true),
    }));
  };

  const updateValue = (key, parameter, value) => {
    setMenuContext((prevState) => ({
      ...prevState,
      menuEdit: utilMenu.updateValue(prevState.menuEdit, key, parameter, value),
    }));
  };

  return (
    <div
      className="frame-container"
      style={{ background: getTheme().palette.neutralLighter }}
    >
      <EditableMenuTitle addMenuItem={addMenuItem} />
      <EditableMenuDropper
        onDrop={(editableMenuItem, monitor) => {
          if (!!monitor.isOver({ shallow: true })) {
            moveMenuItem(editableMenuItem.key, null);
          }
        }}
      >
        <div
          style={{
            color: getTheme().palette.themePrimary,
          }}
        >
          Move to Top
        </div>
      </EditableMenuDropper>
      {menuContext.menuEdit?.map((child, index) => {
        return (
          <EditableMenuItem
            key={child.key ?? index}
            item={child}
            updateValue={updateValue}
            moveMenuItem={moveMenuItem}
            addMenuItem={addMenuItem}
            removeMenuItem={removeMenuItem}
          />
        );
      })}
    </div>
  );
};
